import { FC } from "react"
import { useNavigate, useSearchParams } from "react-router-dom"
import { useFetchRateTableConfigsQuery } from "../../../../redux/queries"
import BrandAutocomplete from "../../brand-autocomplete"
import RateTableConfigTable from "./table"
import { Brand } from "../../../../types"

interface ConfigRateTableProps {
  brands: Brand[]
}

const ConfigRateTable: FC<ConfigRateTableProps> = ({ brands }) => {
  const navigate = useNavigate()
  const [searchParams, setSearchParams] = useSearchParams()
  const selectedBrandId = searchParams.get("brand_id") ?? ""

  const setSelectedBrandId = (id: string) => {
    setSearchParams(prev => {
      const next = new URLSearchParams(prev)
      if (id) next.set("brand_id", id)
      else next.delete("brand_id")
      return next
    })
  }

  const { data, isFetching } = useFetchRateTableConfigsQuery(
    { brand_id: selectedBrandId ?? "" },
    { skip: !selectedBrandId }
  )

  return (
    <div>
      <BrandAutocomplete
        brands={brands}
        selected={selectedBrandId}
        hideLabel
        onChange={setSelectedBrandId}
      />

      <div className="pt-6">
        {selectedBrandId ? (
          <RateTableConfigTable
            data={data ?? []}
            isFetching={isFetching}
            onSelect={id => navigate(`/config-admin/rate-table/${id}`)}
          />
        ) : null}
      </div>
    </div>
  )
}

export default ConfigRateTable
